<template>
	<div v-if="user.user.id != userFollow.id">
		<div v-if="!user.user.siguiendo.find(seguido => seguido == userFollow.id)">
			<button class="button is-small is-info is-fullwidth" :disabled="clicked" @click.prevent="follow">Seguir</button>
		</div>
		<div v-else>
			<button class="button is-small is-light is-fullwidth" :disabled="clicked" @click.prevent="unfollow">Dejar de seguir</button>
		</div>
	</div>
	
</template>

<script>
	import { mapState } from 'vuex'

	export default {
		props:{
			userFollow: {
				type: Object,
				required: true
			}
		},
		name: 'SeguirButton',

		data() {
			return {
				clicked: false
			};
		},
		methods:{
			follow(){
				//console.log('follow user ' + this.userFollow.name)
				this.$store.dispatch('user/followUser',{ id: this.userFollow.id })
				this.clicked = true
			},
			unfollow(){
				this.$store.dispatch('user/unfollowUser',{ id: this.userFollow.id })
				this.clicked = true
			}
		},
		computed: mapState('user',['user'])
	};
</script>

<style lang="css" scoped>
</style>
